const TENANT_API_KEY_PARAM = 'x-storyteller-api-key';

type RequestParams = Record<string, unknown>;

const isRequestParams = (params: unknown): params is RequestParams =>
  typeof params === 'object' && params !== null;

const setTenantApiKeyParam = (
  params: unknown,
  tenantApiKey: string
): URLSearchParams | RequestParams => {
  if (params instanceof URLSearchParams) {
    params.set(TENANT_API_KEY_PARAM, tenantApiKey);
    return params;
  }

  const requestParams = isRequestParams(params) ? params : {};
  requestParams[TENANT_API_KEY_PARAM] = tenantApiKey;
  return requestParams;
};

export default setTenantApiKeyParam;
